import { Input, Spin, Typography } from 'antd'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import React, { useEffect, useState } from 'react'
import { requestDetailInfoPost } from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
dayjs.extend(utc)
dayjs.extend(timezone)
const { Text } = Typography

const Description = ({ id, loading, setLoading }) => {
  const [detail, setDetail] = useState(null)

  const getDetailRequest = async (id) => {
    setLoading(true)
    try {
      const res = await requestDetailInfoPost(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setDetail(res.data)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    if (id) {
      getDetailRequest(id)
    }
  }, [])

  // Thêm hoặc cập nhật comment

  // Bắt đầu chỉnh sửa

  return (
    <div style={{ maxWidth: '100%', margin: 'auto', padding: '0px 26px' }}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <div>
          <div>Mô tả</div>
          <Input.TextArea
            label="Mô tả"
            name="description"
            style={{ padding: '0px 8px' }}
            value={detail?.description}
          >
            <Input.TextArea placeholder="Nhập nội dung" maxLength={255} />
          </Input.TextArea>
        </div>
      )}
    </div>
  )
}

export default Description
